/**
 * @generated SignedSource<<c529d4a11622edcc9017dd5df988d867>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GlobalLayoutContextNavbarFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GlobalBannerFragment" | "GlobalNavbarFragment" | "isFeatureEnabledFragment">;
  readonly " $fragmentType": "GlobalLayoutContextNavbarFragment";
};
export type GlobalLayoutContextNavbarFragment$key = {
  readonly " $data"?: GlobalLayoutContextNavbarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalLayoutContextNavbarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GlobalLayoutContextNavbarFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GlobalNavbarFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GlobalBannerFragment"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "isFeatureEnabledFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GalleryUser",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "dbid",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Viewer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b75245fdd55c21c0c2cfc604d975a285";

export default node;
